
<template>
  <span v-show="false"></span>
</template>
<script>
import store from '../store'
import { map, uniqBy } from 'lodash-es'

export default {
  name: 'InitialData',
  data () {
    return { ...window.vueData.initialData }
  },
  computed: {
    getDataKeyActionSetupLookup () {
      return {
        cartData: 'setCartData',
        productBadges: 'setProductBadges',
        config: 'setConfig',
        products: 'setLiveProducts',
        selectedProductCodeId: 'setSelectedProductCodeId',
        previewOrder: 'setPreviewOrderData',
        uriWithoutOffset: 'setUriWithoutOffset',
        isTopLevelCategory: 'setIsTopLevelCategory',
        productCategoryData: 'setProductCategoryData',
        mapPoints: 'setMapPoints',
        currentPageNumber: 'setCurrentPageNumber',
        selectedCurrency: 'setSelectedCurrency',

        // Variations
        allVariations: 'setAllVariations',
        relatedVariationData: 'setRelatedVariationData',
        variationsActive: 'setVariationsActive',
        variationFilterQueryStringVar: 'setVariationFilterQueryStringVar',
        activeVariationFilters: 'setActiveVariationFilters',
        variationRecordsUsed: 'setVariationRecordsUsed',
        productVariationInfoData: 'setProductVariationInfoData',
        variationMergeDuplicateValuesByName: 'setVariationMergeDuplicateValuesByName',

        // Attributes
        allAttributes: 'setAllAttributes',
        relatedAttributeData: 'setRelatedAttributeData',
        attributesActive: 'setAttributesActive',
        attributeFilterQueryStringVar: 'setAttributeFilterQueryStringVar',
        activeAttributeFilters: 'setActiveAttributeFilters',
        attributeRecordsUsed: 'setAttributeRecordsUsed',
        productAttributeInfoData: 'setProductAttributeInfoData',
        attributeMergeDuplicateValuesByName: 'setAttributeMergeDuplicateValuesByName',

        // Tags
        activeTagFilters: 'setActiveTagFilters',
        tagRecordsUsed: 'setTagRecordsUsed',
        filterQueryStringVar: 'setFilterQueryStringVar',
        listingTagGroupCombos: 'setListingTagGroupCombos',

        // Cart Product Customizations
        cartProductCustomizationSchemas: 'cartProductCustomizations/initSchemas',
        giftCardOrder: 'giftCards/initAll',
        isCustomerLoggedIn: 'setCustomerLoggedInStatus',

        prescriptionValuesSubcontent: 'setPrescriptionValuesSubcontent',

        glassesSectionData: 'glassesGroupFiltering/setGlassesSectionData',
        sunglassesSectionData: 'glassesGroupFiltering/setSunglassesSectionData',
      }
    }
  },
  mounted () {
    for (const [dataKey, actionSetup] of Object.entries(this.getDataKeyActionSetupLookup)) {
      if (!(dataKey in this)) {
        continue
      }
      this.$store.dispatch(actionSetup, this[dataKey])
    }

    if ('listingVariationGroupCombos' in this) {
      const listingVariationGroupCombosUnique = map(this.listingVariationGroupCombos, (combo) => {
        combo.variations = uniqBy(combo.variations, 'variationId').sort((a, b) =>
          parseInt(a.variationOrder) -
          parseInt(b.variationOrder))
        combo.variationGroupStep = Number(combo.variationGroupStep)
        const activeVariationIds = store.getters.getActiveVariationFilters
        combo.variations.forEach((variation) => {
          variation.active = activeVariationIds.includes(variation.variationId)
        })
        return combo
      })
      listingVariationGroupCombosUnique.sort((a, b) => parseInt(a.variationGroupOrder) -
        parseInt(b.variationGroupOrder))

      // sort listingVariationGroupCombosUnique based on active
      listingVariationGroupCombosUnique.forEach((combo) => {
        combo.variations.sort((a, b) => {
          if (a.active && !b.active) {
            return -1
          }
          if (!a.active && b.active) {
            return 1
          }
          return 0
        })
      })
      store.dispatch('setListingVariationGroupCombos', listingVariationGroupCombosUnique)
    }

    if ('listingAttributeGroupCombos' in this) {
      const listingAttributeGroupCombosUnique = map(this.listingAttributeGroupCombos, (combo) => {
        const activeAttributeIds = store.getters.getActiveAttributeFiltersValueIds
        combo.attributes.forEach((attribute) => {
          attribute.active = activeAttributeIds.includes(attribute.attributeId)
        })
        return combo
      })

      //  sort listingAttributeGroupCombosUnique based on active
      listingAttributeGroupCombosUnique.forEach((combo) => {
        combo.attributes.sort((a, b) => {
          if (a.active && !b.active) {
            return -1
          }
          if (!a.active && b.active) {
            return 1
          }
          return 0
        })
      })
      store.dispatch('setListingAttributeGroupCombos', listingAttributeGroupCombosUnique)
    }
  },
  methods: {
    checkConnectionStatus () {
      this.$store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
}
</script>
